/* esm.sh - d3-transition@3.0.1/src/transition/attrTween */
export * from "/*d3-transition@3.0.1/esnext/src/transition/attrTween.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/attrTween.mjs";
